//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';

import { SamplingCampaignRequest } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export enum ChangePurchaseOptionModalStep {
  PURCHASE_OPTIONS = 'purchase-options',
  CONFIRM = 'confirm',
  LOCATION = 'location',
  SETUP = 'setup',
}

interface ChangePurchaseOptionModalContextValue {
  formMethods: UseFormReturn<SamplingCampaignRequest>;
  handleFormSubmit: (data: SamplingCampaignRequest) => Promise<void>;
  isPending: boolean;
  setStep: (step: ChangePurchaseOptionModalStep) => void;
  step: ChangePurchaseOptionModalStep;
  submissionError: string | null;
}

const ChangePurchaseOptionModalContext = createContext<
  ChangePurchaseOptionModalContextValue | undefined
>(undefined);

export const useChangePurchaseOptionModalContext = () => {
  const context = useContext(ChangePurchaseOptionModalContext);
  if (!context) {
    throw new Error(
      'useChangePurchaseOptionModalContext must be used within a ChangePurchaseOptionModalProvider',
    );
  }
  return context;
};

export const ChangePurchaseOptionModalProvider =
  ChangePurchaseOptionModalContext.Provider;
